<template>
    <div class="news-home">
        <!-- <newsHeader ></newsHeader> -->
        <div class="banner">
            <h1 class="title main">
                “首都带首府” <br>
                京银教育合作“互联网+教育”模式       
            </h1>
        </div> 
        <div class="container main">
            <div class="top-part flex-between mb20">
                <div class="content-box">
                    <div class="carousel-part ">
                        <img :src="item.cover" alt=""  @click="$router.push(`/news/headlines/detail/${item.id}`)" v-for="(item,index) in headlines" :key="item.id" v-show="index === currentPage">
                        <div class="carousel-control flex-align-between">
                            <ul class="carousel-nav tc flex-align">
                                <li v-for="(date, index) in headlines" 
                                    :key="index"
                                    v-bind:class="{'carousel-nav-active':currentPage === index}"
                                    @click="gotoPage(index)"
                                    @mouseenter="clearTime(index)"
                                    @mouseleave="runInv()">
                                    <strong class="f28">{{dayjs(date.createTime).format('DD')}}</strong><br>{{dayjs(date.createTime).format('YYYY-MM')}}
                                </li>
                            </ul>
                            <ul class="arrow-box usn csp f20 tc">
                                <li class="arrow" @click="nextPage()">&gt;</li>
                                <li class="arrow" @click="prevPage()">&lt;</li>
                            </ul>
                        </div>
                        <div class="carousel-article usn" 
                             v-for="(line, index) in headlines" 
                             :key="index"
                             v-show="currentPage === index"
                             @mouseenter="clearTime(index)"
                             @mouseleave="runInv()"
                             @click="$router.push(`/news/headlines/detail/${line.id}`)">
                            <h2>头条新闻</h2>
                            <h3 class="wes-2 f18">{{line.title}}</h3>
                            <p class="wes-3">{{line.introduction}}</p>
                            <span class="look-num db">{{line.views || 0}}</span>
                        </div>
                    </div>
                        <!-- props：cloumn可选值：2 3 4; load:true,false-->
                    <!-- <div class="course-part">
                        <courseView :cloumn="2" ></courseView> 
                        <div>
                            <button class="more-btn" @click="$router.push('/news/course')">点击了解更多课程</button>
                        </div>
                    </div> -->
                </div>
                <div class="aside">
                    <ul class="aside-nav flex-align-evenly f16">
                        <li class="composite" @click="newsType=true" :class="{'active-list':newsType}">综合新闻</li>
                        <li class="topic" @click="newsType=false" :class="{'active-list':!newsType}">专题新闻</li>
                    </ul>
                    <ul class="aside-list">
                        <li v-for="(news, index) in newsList" :key="index" @click="goNewsList(news)">
                            <h3 class="f16 wes">{{news.title}}</h3>
                            <p class="wes-2 f12">{{news.introduction}}</p>
                            <div class="summary flex-align-between">
                                <span class="date">{{news.updateTime}}</span>
                                <span class="look-num">{{news.views || 0}}</span>
                            </div>
                        </li>
                    </ul>
                    <button class="more-btn mt0" v-show="newsType" @click="$router.push('/news/composite')">查看更多</button>
                    <button class="more-btn mt0" v-show="!newsType" @click="$router.push('/news/topic')">查看更多</button>
                </div>
            </div>
            <div class="middle-part flex-between">
                <div class="section section-school">
                    <div class="subtitle flex-align-between">
                        <h2 class="left">学校风采</h2>
                        <button class="csp f12 blue" @click="$router.push('/news/school')">查看更多&gt;</button>
                    </div>
                    <div class="section-content">
                        <schoolView :pageSize="3"></schoolView>  <!-- props: column：可选值2 3 4;-->
                        <button class="more-btn" @click="$router.push('/news/school')">查看更多</button>
                    </div>
                </div>
                <div class="section section-student">
                     <div class="subtitle flex-align-between">
                        <h2 class="right">学员风采</h2>
                        <button class="csp f12 blue" @click="$router.push('/news/student')">查看更多&gt;</button>
                     </div>
                     <div class="section-content">
                         <studentView :pageSize="3"></studentView> <!-- props: column：可选值2 3 4-->
                          <button class="more-btn" @click="$router.push('/news/student')">查看更多</button>
                     </div>
                </div>
            </div>
            <div class="bottom-part">
                <div class="subtitle">
                     <h2 class="">学员成果</h2>
                </div>
                <studentStyle :cloumn="4"></studentStyle> <!-- props：cloumn可选值：2 3 4; margin默认值0 -->
                <div>
                    <button class="more-btn" @click="$router.push('/news/student')">查看更多</button>
                </div>
            </div>
        </div>
        <scorllTop></scorllTop>
        <!-- <footer-view></footer-view> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            newsType:true,
            isNav:true,
            currentPage:0,
            timer:null,
            compositeList:[{
                title:'抗击疫情，网络云课程',
                introduction:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                updateTime:'2020.06.21',
                views:1757,
            },{
                title:'抗击疫情，网络云课程',
                introduction:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                desintroductioncribe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                introduction:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                introduction:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },
            {
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },
            {
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            }],
             topicList:[{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },{
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },
            {
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            },
            {
                title:'【专题】抗击疫情，网络云课程',
                describe:'7月17日，由宁在全国上下共同抗击新型冠状病毒肺炎期间，为进一步做好服务保障防控疫情期间中小学校“停课不停教、停课...',
                time:'2020.06.21',
                lookNum:1757,
            }],
            dateNav:[{
                day:'03',
                month:'2020.06'
            },
            {
                day:'03',
                month:'2020.06'
            },{
                day:'03',
                month:'2020.06'
            }
            ,{
                day:'03',
                month:'2020.06'
            }
            ,{
                day:'03',
                month:'2020.06'
            }],
            imgList:[
                require("../../assets/home/brand.png"),
                require("../../assets/home/pause.png"),
                require("../../assets/home/main.png"),
                require("../../assets/home/internet.png"),
                require("../../assets/home/introduction.png"),
            ],
            headlines:[{
                id:123,
                image:require("../../assets/home/brand.png"),
                title:'123教育远程互助工程“北3教育远程互助工3教育远程互助工3教育远程互助工3教育远程互助工京-银川”“互联网+教育” “双优云桥”项目工作简报 第一期',
                describe:'为深入推进“首都带首府”深入推进“首都带首府深入推进“首都带首府深入推进“首都带首府深入推进“首都带首府深入推进“深入推进“首都带首府深入推进“深入推进“首都带首府深入推进“深入推进“首都带首府深入推进“深入推进“首都带首府深入推进“首都带首府深入推进“首都带首府京银教育合作，2020年1月2日下午，首都教育远程互助工程“北京-银川”“互联网+教育”首都师范大学“双优云桥”项目观摩活动在银川召开，来自首都师范大学的专家团队，银川市各县（市）区教（体）育局局长，“双优云桥”项目学校校长，“一带一路”京银共读项目学校主管教学副校长、教导主任及各校...',
                lookNum:1757,
            },{
                id:345,
                image:require("../../assets/home/pause.png"),
                title:'456育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥”项目工作简报 第一期',
                describe:'为深入推进“首都带首府”京银教育合作，2020年1月2日下午，首都教育远程互助工程“北京-银川”“互联网+教育”首都师范大学“双优云桥”项目观摩活动在银川召开，来自首都师范大学的专家团队，银川市各县（市）区教（体）育局局长，“双优云桥”项目学校校长，“一带一路”京银共读项目学校主管教学副校长、教导主任及各校...',
                lookNum:1757,
            },{
                id:678,
                image:require("../../assets/home/main.png"),
                title:'789教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥”项目工作简报 第一期',
                describe:'为深入推进“首都带首府”京银教育合作，2020年1月2日下午，首都教育远程互助工程“北京-银川”“互联网+教育”首都师范大学“双优云桥”项目观摩活动在银川召开，来自首都师范大学的专家团队，银川市各县（市）区教（体）育局局长，“双优云桥”项目学校校长，“一带一路”京银共读项目学校主管教学副校长、教导主任及各校...',
                lookNum:1757,
            },{
                id:789,
                image:require("../../assets/home/internet.png"),
                title:'121515首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥”项目工作简报 第一期',
                describe:'为深入推进“首都带首府”京银教育合作，2020年1月2日下午，首都教育远程互助工程“北京-银川”“互联网+教育”首都师范大学“双优云桥”项目观摩活动在银川召开，来自首都师范大学的专家团队，银川市各县（市）区教（体）育局局长，“双优云桥”项目学校校长，“一带一路”京银共读项目学校主管教学副校长、教导主任及各校...',
                lookNum:1757,
            },{
                id:111,
                image:require("../../assets/home/introduction.png"),
                title:'748415首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥”项目工作简报 第一期',
                describe:'为深入推进“首都带首府”京银教育合作，2020年1月2日下午，首都教育远程互助工程“北京-银川”“互联网+教育”首都师范大学“双优云桥”项目观摩活动在银川召开，来自首都师范大学的专家团队，银川市各县（市）区教（体）育局局长，“双优云桥”项目学校校长，“一带一路”京银共读项目学校主管教学副校长、教导主任及各校...',
                lookNum:1757,
            }],
            
        }
    },
    computed:{
       newsList:function(){
        //    console.log(this.newsType);
           if(this.newsType) {
               return this.compositeList 
           } else {
               return this.topicList
           }
       }
    },
    methods: { 
        // 请求综合新闻
        async getCompositeList(){
            let params = {
                clazz:2,
                // isAsc:desc,
                pageNum:1,
                pageSize: 3
            }            
            let resData = await Api.News.GetNewsList(params)
             console.log(resData)
            this.compositeList= resData.rows;
        },
        // 请求专题新闻
        async getTopicList(){
            let params = {
                clazz:3,
                // isAsc:desc,
                pageNum:1,
                pageSize: 3
            }            
            let resData = await Api.News.GetNewsList(params)
             console.log(resData)
            this.topicList = resData.rows;
        },
        // 请求头条新闻
        async getNewsList(){
            let that = this;
            let params = {
                clazz:1,
                isAsc:'desc',
                pageNum:1,
                pageSize: 5
            }            

            let resData = await Api.News.GetNewsList(params)
            console.log(resData)
            this.headlines = resData.rows
            // params.pageNum = this.currentPage;
            // let res = await Api.News.GetNewsList(params)
            // if(res.rows.length < 1) {
            //     this.loadText = '加载已完成'
            //     this.loadClass = false;
            // }
            
            // that.lists = this.lists.concat(resData.rows);


            // that.clickGetList();
         },
        goNewsList(item){
            let _clazz = item.clazz === 2 ? true : false;
            if(_clazz) {
                this.$router.push(`/news/composite/detail/${item.id}`)
            } else {
                this.$router.push(`/news/topic/detail/${item.id}`)
            }
        },
        nextPage() {
            if(this.currentPage === 4) {
                return this.currentPage = 0
            } else {
                return this.currentPage++
            }
        },
        prevPage() {
            if(this.currentPage === 0) {
                return this.currentPage = 4
            } else {
                return this.currentPage--
            }
        },
        gotoPage(index){
            this.currentPage = index;
        },
        clearTime(index) {
            clearInterval(this.timer);
            this.currentPage = index;
        },
        runInv() {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.nextPage();
            }, 3000)
        }
         
    },
    mounted() {
        this.runInv();
        this.getCompositeList();
        this.getTopicList();
        this.getNewsList();
    },
    beforeDestroy() {
    if(this.timer) {
        clearInterval(this.timer);
    }
}
}
</script>

<style lang="less">
    @import "./less/news_home.less";
</style>